// extracted by mini-css-extract-plugin
export default {"heading6":"Heading6_heading6__aTFqI"};